import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "message", "submit", "feature", "legal"];
  couponIsValid = false;

  connect() {
    if (this.hasSubmitTarget) {
      this.updateButtonText();
    }
  }

  validate() {
    let couponCode = this.inputTarget.value;

    fetch("/validate_coupon", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
          .content,
      },
      body: JSON.stringify({ coupon: couponCode }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.valid) {
          this.messageTarget.textContent = "Code promo valide";
          this.messageTarget.classList.add("text-green-600");
          this.messageTarget.classList.remove("text-pink-600");
          // this.submitTarget.textContent = "Publiez l'offre gratuitement";
          this.couponIsValid = true;
          if (this.hasSubmitTarget) {
            this.updateButtonText();
          }
        } else {
          this.messageTarget.textContent = "Invalide ou expiré";
          this.messageTarget.classList.add("text-pink-600");
          this.messageTarget.classList.remove("text-green-600");
          // this.submitTarget.textContent = "Publier l'offre pour 179€ HT";
          this.couponIsValid = false;
          if (this.hasSubmitTarget) {
            this.updateButtonText();
          }
        }
      });
  }

  updateButtonText() {
    const baseText = "Publier l'offre pour 179€ HT";
    let basePrice = 179;
    let totalFeaturePrice = 0;
    let couponValue = 0;
    this.couponIsValid ? (couponValue -= 179) : 0;

    this.featureTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        totalFeaturePrice += parseFloat(checkbox.dataset.price);
      }
    });

    let totalValue = basePrice + totalFeaturePrice + couponValue;

    if (totalValue == 0) {
      this.submitTarget.textContent = "Publier l'offre gratuitement";
      this.legalTarget.textContent = `"Publier l'offre gratuitement"`;
    } else {
      this.submitTarget.textContent = `Publier l'offre pour ${totalValue}€ HT`;
      this.legalTarget.textContent = `"Publier l'offre pour ${totalValue}€ HT"`;
    }

    // const featureText =
    //   totalFeaturePrice > 0 ? ` (Add €${totalFeaturePrice})` : "";
    // this.submitButtonTarget.value = baseText + featureText;
  }
}
